module.exports = __webpack_public_path__ + "static/img/SG.0fabea88.svg";